'use client';

export { default } from './FormLabel';
export * from './FormLabel';
export { default as formLabelClasses } from './formLabelClasses';
export * from './formLabelClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/FormLabel/index.js
// module id = 530
// module chunks = 25